import { BadgeCircle } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { ActiveTool } from '@backrs_ui/grow-ui/src/redux/coachLubav/coachLubav';

import { Box, Typography, SxProps, Theme } from '@mui/material';
import { motion } from 'framer-motion';

type TypingIndicatorProps = Readonly<{
  activeTools?: ActiveTool[];
}>;

export const TypingIndicator = ({ activeTools = [] }: TypingIndicatorProps) => {
  // show the most recently added tool's display name if available, otherwise show the default thinking text
  const currentTool = activeTools.length > 0 ? activeTools[activeTools.length - 1] : null;
  const displayText = currentTool?.display_name ?? appStrings.modules.chatBox.lubavThinking;

  return (
    <Box sx={typingContainerStyle}>
      <BadgeCircle loading={true} size="lg" />
      <Box sx={typingTextContainerStyle}>
        <Typography sx={lubavThinkingTextStyle}>{displayText}</Typography>
        <motion.div
          initial={{ x: '-100%' }}
          animate={{ x: '100%' }}
          transition={{
            duration: 1,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
          style={typingAnimationStyle}
        />
      </Box>
    </Box>
  );
};

const typingContainerStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  height: '30px',
  marginTop: '-5px',
  marginLeft: '-2px',
};

const typingTextContainerStyle: SxProps<Theme> = {
  position: 'relative',
  overflow: 'hidden',
  marginLeft: '16px',
};

const lubavThinkingTextStyle: SxProps<Theme> = {
  fontSize: '11pt',
  color: '#808080',
  position: 'relative',
  zIndex: 1,
};

const typingAnimationStyle: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)',
  zIndex: 2,
} as const;
